<template>
  <custom-dialog class="expression-setting-dialog" width="500px" :title="model.title" :visible="visible" v-on="$listeners" :append-to-body="true">
    <div class="dialog-body">
      <custom-table :data="tableList" :column="tableColumn" @filter="filterChange" @sort="sortChange" :slots="['expression']" :max-height="500">
        <template v-slot:expression="scope">
          <el-input v-model="scope.row.expression" :maxlength="50" :disabled="disabled"></el-input>
        </template>
      </custom-table>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button @click="closeDialog">{{ $t('Common.com_cancel') }}</el-button>
      <el-button type="primary" @click="onConfirm">{{ $t('Common.com_confirm') }}</el-button>
    </div>
  </custom-dialog>
</template>

<script>
/** 值对值匹配表 */

import dialogMixins from '@/mixins/dialog_mixins';

export default {
  mixins: [dialogMixins],
  props: {
    code: String,
    expression: String,
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      tableCode: 'tsl_expression_setting',
      tableList: [],
      visible: true,
    };
  },
  methods: {
    getList() {
      this.getDictionary(this.code, (dic) => {
        const list = dic[this.code];
        const ret = list.map(item => ({
          name: item.name,
          value: item.value,
          expression: '',
        }));
        if (this.expression) {
          const arr = this.expression.split(',');
          if (arr) {
            arr.forEach((item) => {
              const expressionArr = item.split('-');
              const value = expressionArr[0];
              const expression = expressionArr[1];
              const tmp = ret.find(obj => `${obj.value}` === `${value}`);
              if (tmp) {
                tmp.expression = expression;
              }
            });
          }
        }
        this.tableList = ret;
      });
    },
    closeDialog() {
      this.visible = false;
    },
    onConfirm() {
      if (this.disabled) {
        this.closeDialog();
        return;
      }
      this.validate((val) => {
        if (val) {
          const expression = this.tableList.map(item => [item.value, item.expression].join('-')).join(',');
          this.$emit('confirm', expression);
          this.closeDialog();
        }
      });
    },
    validate(cb) {
      // 查哥说允许空值
      // cb = cb || function () {};
      // if (this.tableList.some(item => !item.expression)) {
      //   this.$message.error(tips);
      //   cb(false);
      // }
      cb(true);
    },
  },
  mounted() {
    this.getTableColumn();
    this.getList();
  },
};
</script>

<style></style>
